/**
 * Derives the current deployment environment from the browser hostname.
 *
 * *.omindplatform.com  → PRODUCTION  (red)
 * *.omindplatform.de   → TESTING     (amber)
 * everything else      → DEVELOPMENT (green)
 */
export function getEnvironmentInfo() {
  const { hostname } = window.location;

  if (hostname.endsWith('.omindplatform.com') || hostname === 'omindplatform.com') {
    return { label: 'PRODUCTION', color: 'red' };
  }
  if (hostname.endsWith('.omindplatform.de') || hostname === 'omindplatform.de') {
    return { label: 'TESTING', color: 'amber' };
  }
  return { label: 'DEVELOPMENT', color: 'green' };
}
